import { ErrorHandler, Input, OnInit } from '@angular/core';
import { StatGrid } from 'src/app/open-age/insight/models/stat-grid.model';
import { StatGridService } from 'src/app/open-age/insight/services/stat-grid.service';

export class AnalyticsBaseComponent implements OnInit {
  @Input()
  code: string;

  analytics: StatGrid = new StatGrid();

  constructor(
    private api: StatGridService,
    errorHandler: ErrorHandler
  ) {
  }

  ngOnInit() {
    this.api.get(this.code).subscribe((i) => this.analytics = i);
  }

}
